import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import SidebarItem from "../common/SidebarItem";
import SidebarItemCollapse from "../common/SidebarItemCollapse";
import { Stack } from "@mui/material";
import colorConfigs from "../../configs/colorConfigs";
import sizeConfigs from "../../configs/sizeConfigs";
import appRoutes from "../../routes/appRoutes";
import { Outlet } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';


const drawerWidth = 240;

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window?: () => Window;
}

export default function MainLayout(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(0),
    textAlign: 'center',
    boxShadow: 'unset',
    color: theme.palette.text.secondary,
    // ...theme.applyStyles('dark', {
    //   backgroundColor: '#1A2027',
    // }),
  }));

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };
  const loginUser = JSON.parse(localStorage.getItem("user") || '{}');
  
  const drawer = (
    <div>
      <Toolbar />
      {/* <Divider /> */}
      <List disablePadding>
        <Toolbar sx={{ marginBottom: "0px" }}>
          <Stack 
            // sx={{ width: "100%" }}
            // direction="row"
            justifyContent="center"
            spacing={2}
          >
          <Item >
             {/* <ResourceImg remoteSrc={(localStorage.getItem("logo") != undefined && localStorage.getItem("logo") != null)?`logo/${localStorage.getItem("logo")}`:''} 
              src={'/images/floboard_logo.png'}  className="img-circle" alt="icons"  style={{objectFit: 'cover',  width:"90%", marginTop:"20px"}} /> */}
            <img src="/images/floboard_logo.png" alt="profile-img"  style={{objectFit: 'cover',  width:"90%", marginTop:"0px"}}/> 
          </Item>
          <Item className="m-0">
            <p  style={{color: 'rgb(0,23,193)', marginBottom:'0.5rem', marginTop:'0.8rem'}}>{(localStorage.getItem("org_name") != undefined && localStorage.getItem("org_name") != null)?localStorage.getItem("org_name") : ""}</p>
          </Item>
        </Stack>
        </Toolbar>
        {appRoutes.map((route, index) => (
          route.sidebarProps ? (
            route.child ? (
              <SidebarItemCollapse item={route} key={index} />
            ) : (
              <SidebarItem item={route} key={index} />
            )
          ) : null
        ))}
      </List>
    </div>
  );

  // Remove this const when copying and pasting into your project.
  const container = window !== undefined ? () => window().document.body : undefined;
  const location = useLocation();

  return (
    (location.pathname != "/verify" && location.pathname != "/reset" && location.pathname != "/403" && location.pathname != "/404" &&
      !location.pathname?.includes('/keyconfirm') && !location.pathname?.includes('download/encryptsvg') &&
      !location.pathname?.includes('/management/download/svg/')
    ) ?
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: "#fff",
          height: "65px"
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {/* <Typography variant="h6" noWrap component="div">
            Responsive drawer
          </Typography> */}
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <div className='mt_2'>
          <Outlet />
        </div>
      </Box>
    </Box>:
     <Box sx={{ display: "flex" }}>
    
     <Box
       component="main"
       sx={{
         flexGrow: 1,
        
         width: `calc(100% - ${sizeConfigs.sidebar.width})`,
         minHeight: "100vh",
         backgroundColor: colorConfigs.mainBg
       }}
     >
       <Outlet />
     </Box>
   </Box>
  );
}
